
import _ from 'lodash';
import moment from 'moment';
import { ORDER_SUCCESS } from '../../constants';
import { displayPhoneNumberFormat, isStringNotNull } from '../../utils/tools';
import { getAllUsers, getShopUsers, generateCsvFileForOneShop, generateCsvFileForALLShops } from '../../apis/backend';
import { saveAs } from 'file-saver';
import { debounce } from 'lodash';

export const initUsers = async (props, component) => {
  const { isAllShops, page } = props;
  component.setState({ isLoading: true })
  const users = isAllShops ? await getAllClients(component.state.searchTerm, page) : await getShopUsers()
  formatUsersData(users, component, true)
};

export const handleSearchChange = async (e, component) => {
  await component.setState({ searchTerm: e.target.value });

  debouncedSearchAPI(component);
};

const handleLocalSearch = (component) => {
  const { searchTerm, allClients } = component.state;
  const dataToUse = allClients.filter(client =>
    client.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  component.setState({ currentClients: { data: dataToUse, size: dataToUse.length } });
};

const debouncedSearchAPI = debounce(async (component) => {
  const { searchTerm, allClients, totalUsers } = component.state;
  const { isAllShops, page } = component.props;
  if (searchTerm.length < 5 && isAllShops) {
    component.setState({ currentClients: { data: allClients, size: totalUsers } });
    return;
  }
  if (isAllShops) {
    try {
      component.setState({ isLoading: true });
      const response = await getAllClients(searchTerm, { numPage: 0, rowsPerPage: page.rowsPerPage });

      if (response?.data) {
        formatUsersData(response, component);
      } else {
        component.setState({ currentClients: { data: null, size: 0 }, isLoading: false });
      }
    } catch (error) {
      console.error('Erreur lors de la recherche de clients :', error);
      component.setState({ isLoading: false });
    }
  }
  else {
    handleLocalSearch(component);
  }
}, 500);

export const handleSearchBlur = (component) => {
  const { searchTerm, previousSearchTerm } = component.state;
  if (searchTerm === previousSearchTerm) return;
  component.setState({ previousSearchTerm: searchTerm });

  debouncedSearchAPI(component);
};

export const handleClick = (event, component) => {
  component.setState({ anchorEl: event.currentTarget });
};

export const handleClose = component => {
  component.setState({ anchorEl: null });
};

export const handleExportToCsv = async (component) => {
  component.setState({ anchorEl: null });
  const { isAllShops } = component.props;
  const response = isAllShops
    ? await generateCsvFileForALLShops({ generateCsv: true })
    : await generateCsvFileForOneShop({ generateCsv: true });

  saveAs(response, 'Liste clients');

};
export const handleRowClick = (client, component) => {
  component.setState({ modalOpen: true, client });
};
export const handleCloseModal = component => {
  component.setState({ modalOpen: false });
};
export const getAllClients = async (searchTerm, page) => {
  const withFilter = searchTerm.length > 4
  const filter = { email: searchTerm.toLowerCase() };
  const response = await getAllUsers(page, filter, withFilter)
  return response
}


const formatUserData = (userId, index) => {
  const {
    firstName = '',
    lastName = '',
    email,
    numero: number = '',
    promotions,
    points = '',
    birthdate = '',
    cards = {},
    newsletter = false,
    shopIds = [],
    billing = []
  } = userId;

  const { exp_month: expMonth = '', exp_year: expYear = '', numb: cardNumber = '' } = _.keys(cards).length
    ? cards[_.keys(cards)[0]]
    : cards;

  const shopWithFirstOrder = _.orderBy(shopIds, ({ firstOrderTime }) => firstOrderTime || '', ['asc'])[0];
  const sortedBillings = _.orderBy(billing, ['date'], ['desc']);
  const lastBilling = sortedBillings[0] || {};

  const { nbTransaction, nbTransactionCanceled, totalMoneySpent } = _.reduce(
    billing, (acc, bill) => {
      const { status, priceOrder = 0 } = bill;
      if (status === ORDER_SUCCESS) {
        acc.nbTransaction++;
      } else {
        acc.nbTransactionCanceled++;
      }
      acc.totalMoneySpent += priceOrder;
      return acc;
    },
    { nbTransaction: 0, nbTransactionCanceled: 0, totalMoneySpent: 0 }
  );

  return {
    firstName,
    lastName,
    email: email || '--',
    number: displayPhoneNumberFormat(number),
    promotions: promotions ? _.values(promotions) : [],
    expMonth,
    expYear,
    points,
    birthdate,
    cardNumber,
    newsletter,
    id: index,
    lastBilling,
    nbTransaction,
    nbTransactionCanceled,
    totalMoneySpent: Math.round(totalMoneySpent * 100) / 100,
    billing,
    dateObj: shopWithFirstOrder?.firstOrderTime ? moment(shopWithFirstOrder.firstOrderTime) : null
  };
};

const updateComponentState = (component, clients, users, searchTerm) => {
  const orderedClients = _.orderBy(clients, ({ dateObj }) => dateObj || '', ['desc']);
  const currentClients = {
    data: orderedClients,
    size: isStringNotNull(searchTerm) && searchTerm.length > 4 ? users?.fetchedUsers : users?.totalUsers
  };
  component.setState({
    clients: orderedClients,
    currentClients,
    isLoading: false
  });
};

export const formatUsersData = (users, component, isFirstTime) => {
  const allUsers = users?.data;
  if (!allUsers) {
    component.setState({
      currentClients: {},
      isLoading: false,
      totalUsers: 0
    });
    return;
  }
  const clients = _.map(allUsers, (userId, index) => formatUserData(userId, index));
  if (!isStringNotNull(component.state.searchTerm) && isFirstTime) {
    const clientsWithoutFilter = _.map(allUsers, (userId, index) => formatUserData(userId, index));
    const orderedClients = _.orderBy(clientsWithoutFilter, ({ dateObj }) => dateObj || '', ['desc']);
    component.setState({ allClients: orderedClients, totalUsers: users?.totalUsers });
  }
  updateComponentState(component, clients, users, component.state.searchTerm);
};


